export const STATUS_TONE = {
  "Verified & Operational": "border-emerald-600 text-emerald-700 bg-emerald-50",
  "Implemented — Verification Pending": "border-sky-600 text-sky-700 bg-sky-50",
  "Partially Implemented": "border-amber-500 text-amber-700 bg-amber-50",
  "Not Implemented": "border-red-600 text-red-700 bg-red-50",
  "Not Applicable": "border-slate-300 text-slate-500 bg-slate-50",
  "Unknown / Insufficient Evidence": "border-orange-500 text-orange-700 bg-orange-50",
  "Owner Approval Required": "border-violet-500 text-violet-700 bg-violet-50",
  "Legal Review Required": "border-fuchsia-600 text-fuchsia-700 bg-fuchsia-50",
  Draft: "border-slate-400 text-slate-600 bg-slate-50",
  "Under Review": "border-sky-500 text-sky-700 bg-sky-50",
  Active: "border-emerald-600 text-emerald-700 bg-emerald-50",
  Approved: "border-emerald-600 text-emerald-700 bg-emerald-50",
  Retired: "border-slate-300 text-slate-400 bg-slate-50",
  "Review Due": "border-amber-500 text-amber-700 bg-amber-50",
};

const L = (key, label, long = false) => ({ key, label, long });

export const REGISTER_CONFIG = {
  activities: {
    title: "Processing Register",
    subtitle: "Record of processing activities (UK GDPR Art. 30) for RetroTrack data.",
    statusKey: "record_statuses",
    columns: ["data_subjects", "sensitivity"],
    fields: [
      L("name", "Activity name"), L("purpose", "Purpose", true), L("data_subjects", "Data subjects", true),
      L("data_categories", "Data categories", true), L("sensitivity", "Sensitivity"), L("controller", "Controller"),
      L("provider_role", "Castlewood role"), L("lawful_basis", "Lawful basis (controller)", true),
      L("retention", "Retention", true), L("storage_location", "Storage location", true),
      L("recipients", "Recipients", true), L("international_transfers", "International transfers", true),
      L("security_measures", "Security measures", true), L("owner", "Owner"), L("notes", "Notes", true),
    ],
  },
  subprocessors: {
    title: "Subprocessor Register",
    subtitle: "Third parties that process RetroTrack data on Castlewood Software Ltd's behalf.",
    statusKey: "record_statuses",
    columns: ["service", "location"],
    fields: [
      L("name", "Subprocessor"), L("service", "Service", true), L("purpose", "Purpose", true),
      L("data_processed", "Data processed", true), L("location", "Location"), L("transfer_mechanism", "Transfer mechanism"),
      L("contract_reference", "Contract / DPA reference"), L("security_assurance", "Security assurance"),
      L("owner", "Owner"), L("notes", "Notes", true),
    ],
  },
  evidence: {
    title: "Evidence & Gap Tracker",
    subtitle: "Requirement → control → evidence. Statuses reflect verified evidence only.",
    statusKey: "evidence_statuses",
    columns: ["framework", "priority"],
    fields: [
      L("requirement", "Requirement"), L("framework", "Framework / source"), L("control", "Control", true),
      L("implementation", "Implementation", true), L("evidence", "Evidence reference", true),
      L("owner", "Owner"), L("priority", "Priority (Critical/High/Medium/Low)"), L("review_date", "Review date"),
      L("notes", "Notes", true),
    ],
  },
};
